module.exports = __webpack_public_path__ + "img/turkcell-foursquare-launch-07.00589de1.jpg";